import { createComponent } from '@carvana/merch-components';
import SuggestionLink, { SuggestionLinkProps } from './SuggestionLink';

export const SuggestionSectionContainer = createComponent('div', {
  className: 'flex flex-col gap-16'
});

export const SectionTitle = createComponent('span', {
  className: 'text-base font-semibold leading-5 text-blue-6'
});

export const SectionContent = createComponent('div', {
  className: 'flex flex-wrap gap-8'
});

export const SuggestionLinkWrapper = createComponent<
  Partial<SuggestionLinkProps>
>(SuggestionLink, {
  className:
    'flex items-center gap-8 rounded border border-grey-2 bg-white px-12 py-[7px] transition-all hover:border-grey-3 hover:bg-grey-1'
});

export const SuggestionLinkText = createComponent('span', {
  className: 'select-none whitespace-nowrap text-sm text-blue-6'
});

export const modalStyles = 'no-scrollbar overflow-x-auto px-16';
